import styled from 'styled-components';

interface ICategoryRect {
    background?: string;
}

export const CategoryRect = styled.div<ICategoryRect>`
    width: 1.375rem;
    height: 1.375rem;
    border-radius: 0.25rem;
    transition: background ${({ theme }) => theme.transitions.hover};
    background: ${({ background }) => background};
`;
